__turbopack_context__.v({
  "container": "_8PdXbG_container",
  "content": "_8PdXbG_content",
  "shimmer": "_8PdXbG_shimmer",
  "text": "_8PdXbG_text",
  "text-bar-sweep": "_8PdXbG_text-bar-sweep",
});
